<template>
  <dialog :open="isOpen" class="default-dialog">
    <div class="dialog-content">
      <header class="dialog-header">
        <div>
          <h2 class="dialog-title">{{ title }}</h2>
          <p v-if="versionLabel" class="dialog-meta">{{ versionLabel }}</p>
        </div>
        <button @click="closeModal" class="close-icon-button">✖</button>
      </header>

      <main class="dialog-body scroll">
        <div v-if="loading">Carregando...</div>
        <div v-else-if="error" class="error">{{ error }}</div>
        <div v-else class="legal-html" v-html="html"></div>
      </main>
    </div>
  </dialog>
</template>

<script>
import LegalHttp from "@/http/LegalHttp.js";

export default {
  name: "Policy",
  props: {
    isOpen: Boolean,
  },
  data() {
    return {
      title: "Política de Privacidade",
      loading: false,
      error: "",
      html: "",
      version: "",
      publishedAt: "",
    };
  },
  computed: {
    versionLabel() {
      if (!this.version) return "";
      return `Versão ${this.version}${this.publishedAt ? " · " + this.publishedAt : ""}`;
    },
  },
  watch: {
    isOpen(v) {
      if (v) this.load();
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    async load() {
      this.loading = true;
      this.error = "";
      try {
        const res = await LegalHttp.getPublicByType("privacy");
        this.html = res.data?.content_html || "";
        this.version = res.data?.version || "";
        this.publishedAt = res.data?.published_at || "";
        if (res.data?.title) this.title = res.data.title;
      } catch (e) {
        this.error = "Não foi possível carregar a Política de Privacidade.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.default-dialog {
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(4px);
  width: 100vw;
  height: 100vh;
}
dialog {
  pointer-events: none;
  opacity: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
dialog[open] {
  opacity: 1;
  pointer-events: inherit;
}
.dialog-content {
  width: 740px;
  max-width: 100%;
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}
.dialog-title {
  font-size: 22px;
  margin: 0;
}
.dialog-meta {
  margin: 4px 0 0;
  font-size: 12px;
  color: #7c3aed;
  font-weight: 700;
}
.close-icon-button {
  border: none;
  background: transparent;
  cursor: pointer;
}
.dialog-body {
  max-height: 60vh;
  overflow: auto;
}
.legal-html {
  font-size: 14px;
  line-height: 1.5;
  color: #334155;
}
.legal-html :deep(h3) {
  margin: 14px 0 6px;
  font-size: 15px;
}
.error {
  color: #b91c1c;
}
</style>
